export default __webpack_public_path__ + "static/media/ic-support.533e9972.svg";